<div class="gb-limit-width">
  <div class="report-container">
    <h3 translate="STAFF.SECTION"></h3>
    <div class="gb-tile-grid">
      @for (report of staffReportCardItems; track report) {
        <gb-download-card
          (click)="openDownloadReportDialog(report.type, report.name)"
          [cardName]="report.name"
          [cardDescription]="report.description"
        ></gb-download-card>
      }
    </div>
  </div>
</div>
